import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import { initLiff } from './services/liff';

// Define routes
const routes = [
  {
    path: '/',
    name: 'preorder-list',
    component: () => import('./pages/PreorderList.vue'),
  },
  {
    path: '/preorder/create',
    name: 'preorder-create',
    component: () => import('./pages/PreorderCreate.vue'),
  },
  {
    path: '/preorder/:id',
    name: 'preorder-detail',
    component: () => import('./pages/PreorderDetail.vue'),
  },
  {
    path: '/preorder/:id/edit',
    name: 'preorder-edit',
    component: () => import('./pages/PreorderEdit.vue'),
  },
];

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Initialize LIFF and mount app
async function bootstrap() {
  try {
    // Initialize LIFF
    await initLiff();

    // Create and mount Vue app
    const app = createApp(App);
    app.use(router);
    app.mount('#app');
  } catch (error) {
    console.error('Failed to initialize app:', error);
    // Show error message to user
    const appEl = document.getElementById('app');
    if (appEl) {
      appEl.innerHTML = `
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; padding: 20px; text-align: center;">
          <div style="font-size: 48px; margin-bottom: 16px;">😵</div>
          <h1 style="font-size: 18px; color: #333; margin-bottom: 8px;">載入失敗</h1>
          <p style="font-size: 14px; color: #666;">請重新開啟此頁面或稍後再試</p>
        </div>
      `;
    }
  }
}

bootstrap();
